export const GET_MENU_LIST = 'menu/get_menu_list';
export const SET_MENU_LIST = 'menu/set_menu_list';
export const SET_MENU_ID = 'menu/set_menu_id';
export const SET_MENU_COLLAPSED = 'menu/set_menu_collapsed';
export const SET_MOBILE_MENU='menu/set_mobile_menu';